const getStored = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
const setStored = (key, val) => { try { localStorage.setItem(key, val); } catch {} };

let disabled = true;

const recompute = () => {
  const consent = getStored('sniptrip_cookie_consent');
  const adminOff = getStored('sniptrip_tracking_disabled') === '1';
  disabled = consent !== '1' || adminOff;
  // Stop Clarity session recording when tracking is disabled (consent declined or admin toggle off).
  // clarity() queues commands before the script loads, so this is safe to call at any time.
  if (disabled && typeof window.clarity === 'function') window.clarity('stop');
};

recompute();

export const setAnalyticsEnabled = (on) => {
  setStored('sniptrip_tracking_disabled', on ? '0' : '1');
  recompute();
};

export const setCookieConsent = (accepted) => {
  setStored('sniptrip_cookie_consent', accepted ? '1' : '0');
  recompute();
};

// null = not yet decided, '1' = accepted, '0' = declined
export const getCookieConsent = () => getStored('sniptrip_cookie_consent');

// For the admin toggle UI — reflects stored preference independent of consent
export const analyticsEnabledInitial = getStored('sniptrip_tracking_disabled') !== '1';

const track = (eventName, params = {}) => {
  if (disabled || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
};

export const trackPageView = (title, path) => {
  if (disabled || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', { page_title: title, page_path: path });
};

export default track;
